import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { ISession } from '../../models/session';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export interface ISearchCriteriaFilter {
  field: string;
  operator: string;
  value: string;
}
export interface ISegment {
  segment_id?: string;
  name: string;
  search_criteria: { filters: ISearchCriteriaFilter[] };
  created_at?: string;
  users_count?: string;
}

export interface ISegmentUser {
  user_id: string;
  first_name: string;
  last_name: string | null;
  email: string;
}

export interface ISegmentPreview {
  users_count: number;
  users: ISegmentUser[];
}

@Injectable()
export class SegmentsService extends BasicService {
  private API = config.segments.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
  ) {
    super(authService, translate);
  }

  public getSegments(session: ISession, notify: boolean = false): Observable<ISegment[]> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/segments`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public createSegment(session: ISession, dto: ISegment, notify: boolean = true): Observable<ISegment> {
    return this.http
      .post(`${this.API}/sessions/${session.id}/segments?language=${session.language}`, dto)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateSegment(session: ISession, dto: ISegment, notify: boolean = true): Observable<ISegment> {
    return this.http
      .put(`${this.API}/sessions/${session.id}/segments/${dto.segment_id}?language=${session.language}`, dto)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public deleteSegment(session: ISession, segmentId: string, notify: boolean = true): Observable<string> {
    return this.http
      .delete(`${this.API}/sessions/${session.id}/segments/${segmentId}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public previewSegment(session: ISession, segmentId: string, limit: number = 10, offset: number = 0, notify: boolean = false): Observable<ISegmentPreview> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/segments/${segmentId}/preview?language=${session.language}&limit=${limit}&offset=${offset}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/segments.service.ts